import Box from '@mui/material/Box';
import { styled, type Theme, type SxProps } from '@mui/material/styles';
import clsx from 'clsx';

type Props = {
  className?: string | string[];
  sx?: SxProps<Theme>;
};

const ForgenticLogo = ({ className = 'solid', sx }: Props) => {
  const BoxStyled = styled(Box)(() => ({
    fontSize: 0,
    '& svg': {
      width: '100%',
      height: '100%',
      overflow: 'visible',
    },
    '&.solid svg': {
      fill: 'rgba(183, 195, 14, 1)',
    },
    '&.animated svg': {
      width: '100%',
      height: '100%',
      '& path': {
        fill: 'rgba(183, 195, 14, 1)',
      },
    },
    '&.outlined svg': {
      fill: 'transparent',
      '& path': {
        stroke: 'rgba(183, 195, 14, 1)',
        strokeWidth: 2,
      },
    },
  }));

  return (
    <BoxStyled className={clsx('forgentic-logo', className)} sx={sx}>
      <svg viewBox="0 0 414 38.1" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path d="M 37.99 2.791 L 37.99 0 L 0 0 L 0 37.99 L 37.99 37.99 L 37.99 35.199 C 37.99 30.121 36.015 25.35 32.429 21.764 C 31.36 20.695 30.184 19.768 28.927 18.995 C 30.184 18.222 31.36 17.295 32.429 16.226 C 36.015 12.64 37.99 7.869 37.99 2.791 Z M 32.115 32.407 L 5.583 32.407 L 5.583 21.786 L 18.995 21.786 C 25.434 21.786 30.827 26.347 32.115 32.407 Z M 18.995 16.204 L 5.583 16.204 L 5.583 5.583 L 32.115 5.583 C 30.827 11.643 25.434 16.204 18.995 16.204 Z" />
          <path d="M 61.342 0 C 50.868 0 42.347 8.521 42.347 18.995 C 42.347 29.469 50.868 37.99 61.342 37.99 C 71.816 37.99 80.337 29.469 80.337 18.995 C 80.337 8.521 71.816 0 61.342 0 Z M 61.342 32.407 C 53.946 32.407 47.93 26.39 47.93 18.995 C 47.93 11.599 53.946 5.583 61.342 5.583 C 68.737 5.583 74.754 11.6 74.754 18.995 C 74.754 26.39 68.737 32.407 61.342 32.407 Z" />
          <path d="M 79.764 0 L 79.764 5.583 L 95.968 5.583 L 95.968 37.99 L 101.55 37.99 L 101.55 5.583 L 117.754 5.583 L 117.754 0 L 79.764 0 Z" />
          <path d="M 131.493 21.896 L 131.493 16.313 L 120.181 16.313 L 120.181 21.896 L 131.493 21.896 Z" />
          <path d="M 174.887 0 L 155.892 0 C 145.418 0 136.897 8.521 136.897 18.995 C 136.897 29.469 145.418 37.99 155.892 37.99 L 174.887 37.99 L 174.887 27.905 L 169.304 27.905 L 169.304 32.407 L 155.892 32.407 C 148.496 32.407 142.48 26.39 142.48 18.995 C 142.48 11.6 148.496 5.583 155.892 5.583 L 169.304 5.583 L 169.304 10.085 L 174.887 10.085 L 174.887 0 Z" />
          <path d="M 218.304 2.791 L 218.304 0 L 180.314 0 L 180.314 37.99 L 185.897 37.99 L 185.897 21.787 L 199.309 21.787 C 206.705 21.787 212.721 27.803 212.721 35.199 L 212.721 37.99 L 218.304 37.99 L 218.304 35.199 C 218.304 30.121 216.329 25.35 212.743 21.764 C 211.673 20.694 210.496 19.769 209.239 18.995 C 210.497 18.222 211.673 17.296 212.743 16.226 C 216.329 12.64 218.304 7.869 218.304 2.791 L 218.304 2.791 Z M 199.309 16.204 L 185.897 16.204 L 185.897 5.583 L 212.429 5.583 C 211.141 11.643 205.748 16.204 199.309 16.204 L 199.309 16.204 Z" />
          <path d="M 242.726 0 C 232.252 0 223.731 8.521 223.731 18.995 L 223.731 37.99 L 229.314 37.99 L 229.314 18.995 C 229.314 11.6 235.331 5.583 242.726 5.583 C 250.122 5.583 256.138 11.6 256.138 18.995 L 256.138 37.99 L 261.721 37.99 L 261.721 18.995 C 261.721 8.521 253.2 0 242.726 0 L 242.726 0 Z M 245.526 29.608 L 245.526 24.009 L 239.927 24.009 L 239.927 29.608 L 245.526 29.608 Z" />
          <path d="M 292.594 21.795 L 292.594 16.195 L 286.994 16.195 L 286.994 21.795 L 292.594 21.795 Z M 267.148 0 L 267.148 37.99 L 272.731 37.99 L 272.731 5.583 L 305.138 5.583 L 305.138 0 L 267.148 0 Z" />
          <path d="M 310.566 0 L 310.566 5.583 L 326.769 5.583 L 326.769 37.99 L 332.352 37.99 L 332.352 5.583 L 348.556 5.583 L 348.556 0 L 310.566 0 Z" />
          <path d="M 359.582 38.108 L 359.582 32.509 L 353.983 32.509 L 353.983 38.108 L 359.582 38.108 Z" />
          <path d="M 383.995 0 C 373.521 0 365 8.521 365 18.995 L 365 37.99 L 370.583 37.99 L 370.583 18.995 C 370.583 11.6 376.599 5.583 383.995 5.583 C 391.39 5.583 397.407 11.6 397.407 18.995 L 397.407 37.99 L 402.99 37.99 L 402.99 18.995 C 402.99 8.521 394.469 0 383.995 0 L 383.995 0 Z M 386.795 29.608 L 386.795 24.009 L 381.195 24.009 L 381.195 29.608 L 386.795 29.608 Z" />
          <path d="M 414 37.99 L 414 0 L 408.417 0 L 408.417 37.99 L 414 37.99 Z" />
        </g>
      </svg>
    </BoxStyled>
  );
};

export default ForgenticLogo;
